// @flow
import { getCreator, deleteCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_ACTIVE_PURCHASES: `${environment.apiUrl}/purchase/list/active`,
  GET_PAST_PURCHASES: `${environment.apiUrl}/purchase/list/past`,
  DELETE_OR_CANCEL: `${environment.apiUrl}/purchase/:id`,
});

export const getActivePurchasesApi = getCreator(fetch, endpoints.GET_ACTIVE_PURCHASES);
export const getPastPurchasesApi = getCreator(fetch, endpoints.GET_PAST_PURCHASES);
export const deleteOrCancelOrderApi = deleteCreator(fetch, endpoints.DELETE_OR_CANCEL);



// WEBPACK FOOTER //
// ./src/modules/orders/api.js